<template functional>
  <el-rate
    disabled
    :value="props.row[props.column]"
    :colors="['#FF0000', '#f4d03e', '#008F39']"
  >
  </el-rate>
</template>

<script>
export default {
  name: "RateComponent"
};
</script>
